<div class="dialog-container">
  <!-- Error header -->
  <div class="error-header" *ngIf="appUIComponent.error">
    <mat-icon class="error-icon">{{ appUIComponent.error.icon }}</mat-icon>
  </div>

  <div class="dialog-content">
    <h2 class="dialog-title">{{ appUIComponent.uiTitle }}</h2>
    <p class="dialog-message" [innerHTML]="appUIComponent.uiMessage"></p>

    <!-- Error list with scrollable box -->
    <div
      *ngIf="appUIComponent.error?.errorList && appUIComponent.error!.errorList!.length > 0"
      class="error-list-box"
      scrollActivity
      [scrollActivityCustom]="false"
    >
      <ul class="error-file-list">
        <li *ngFor="let item of appUIComponent.error!.errorList" class="error-file-item">
          <span class="error-file-name">{{ item.fileName }}</span>
          <ol class="error-issue-list">
            <li *ngFor="let issue of item.issues" class="error-issue-item">{{ issue }}</li>
          </ol>
        </li>
      </ul>
    </div>
    <div class="dialog-text-input" *ngIf="appUIComponent.textInput">
      <label class="filter-label">{{ appUIComponent.textInput.label }}</label>
      <input
        type="text"
        class="text-input-field"
        [placeholder]="appUIComponent.textInput.placeholder || ''"
        [(ngModel)]="textInputValue"
      />
    </div>

    <!-- Optional Confirmation Tags -->
    <div class="dialog-confirmation-tags" *ngIf="appUIComponent.confirmationTags && appUIComponent.confirmationTags.length > 0">
      <span
        *ngFor="let tag of appUIComponent.confirmationTags"
        class="confirmation-tag"
      >{{ tag }}</span>
    </div>

    <!-- Optional Dropdowns -->
    <div class="dialog-filters" *ngIf="appUIComponent.dropdowns">
      <div class="filter-group" *ngIf="appUIComponent.dropdowns.countries && appUIComponent.dropdowns.countries.length > 0">
        <label for="countrySelect" class="filter-label">Country:</label>
        <select 
          id="countrySelect" 
          class="filter-select" 
          [(ngModel)]="selectedCountry"
        >
          <option value="">Select field</option>
          <option *ngFor="let country of appUIComponent.dropdowns.countries" [value]="country">
            {{ formatCountryName(country) }}
          </option>
        </select>
      </div>
      
      <div class="filter-group" *ngIf="appUIComponent.dropdowns.setAreas && appUIComponent.dropdowns.setAreas.length > 0">
        <label for="setAreaSelect" class="filter-label">SET Area:</label>
        <select 
          id="setAreaSelect" 
          class="filter-select" 
          [(ngModel)]="selectedSetArea"
        >
          <option value="">Select field</option>
          <option *ngFor="let area of appUIComponent.dropdowns.setAreas" [value]="area">
            {{ area }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="dialog-actions">
    <button
      *ngIf="appUIComponent.showCancel !== false"
      type="button"
      class="btn btn-cancel"
      (click)="onCancel()"
    >
      {{ appUIComponent.cancelText || "Cancel" }}
    </button>
    <button
      *ngIf="appUIComponent.showConfirm !== false"
      type="button"
      class="btn btn-continue"
      (click)="onConfirm()"
    >
      {{ appUIComponent.confirmText || "Confirm" }}
    </button>
  </div>
</div>
